/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfig interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfig(value) {
    if (!('DownloadUrl' in value) || value['DownloadUrl'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfigFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfigFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DownloadUrl': json['DownloadUrl'],
        'SoftUpdateVersion': json['SoftUpdateVersion'] == null ? undefined : json['SoftUpdateVersion'],
        'HardUpdateVersion': json['HardUpdateVersion'] == null ? undefined : json['HardUpdateVersion'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfigToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfigToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DownloadUrl': value['DownloadUrl'],
        'SoftUpdateVersion': value['SoftUpdateVersion'],
        'HardUpdateVersion': value['HardUpdateVersion'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherUpdateConfig.js.map